import * as React from 'react';

import {
  MyAccountPageContainer,
  MyAccountPageContainerProps,
} from '@/components/PrivateContainers/MyAccountPageContainer';

export const MyAccountPrivatePage = ({
  userData,
  onSubmit,
  countries,
  provinces,
  tinDocumentTypes,
  countryOnChange,
  userProducts,
  userProduct,
  groupId,
  userCurrency,
  mobileToken,
  onSubmitFormPhoneValidation,
  onSubmitFormTokenCheck,
  onCancelButton,
  onRequestInfoSubmit,
  disablePage,
}: MyAccountPageContainerProps) => {
  return (
    <div className="flex justify-center  w-full mt-2 lg:mt-10 bg-md-lightGray">
      <div className="w-full bg-md-white mb-20">
        <MyAccountPageContainer
          userData={userData}
          onSubmit={onSubmit}
          countries={countries}
          provinces={provinces}
          tinDocumentTypes={tinDocumentTypes}
          countryOnChange={countryOnChange}
          userProduct={userProduct}
          userProducts={userProducts}
          groupId={groupId}
          userCurrency={userCurrency}
          mobileToken={mobileToken}
          onSubmitFormPhoneValidation={onSubmitFormPhoneValidation}
          onSubmitFormTokenCheck={onSubmitFormTokenCheck}
          onCancelButton={onCancelButton}
          onRequestInfoSubmit={onRequestInfoSubmit}
          disablePage={disablePage}
        />
      </div>
    </div>
  );
};
